<script setup lang="ts">
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import InputQC from '@qicgroupdoha/qic-connect-ds/components/InputQC'
  import InputDateQC from '@qicgroupdoha/qic-connect-ds/components/InputDateQC'
  import BlockTitle from './BlockTitle/BlockTitle.vue'
  import { useI18n } from 'vue-i18n'

  interface Props {
    visa: string
    visaValidityDate?: Date
  }

  const { locale } = useI18n()
  defineProps<Props>()
</script>

<template>
  <WrapperQC
    direction="column"
    gap="var(--spacing-5)"
    :margin="{ top: 'var(--spacing-5)' }"
  >
    <BlockTitle icon="profile" :text="$t('personal_info.visa_information_block.header')" />
    <InputQC
      :model-value="visa"
      name="visaPreapprovalNumber"
      :label="$t('qlm_visa_number')"
      is-valid
      :container-attrs="{ 'data-test': 'visa-input' }"
      disabled
      data-test="visa-input-inner"
    />
    <!-- @vue-ignore -->
    <InputDateQC
      :model-value="visaValidityDate"
      :label="$t('visa_expiry_date')"
      disabled
      :locale="locale"
      :input-props="{
        isValid: true,
        disabled: true,
        containerAttrs: { 'data-test': 'visa-expiry-date-input' },
      }"
      hide-calendar-icon
      name="visaExpireDate"
      data-test="visa-expiry-date-input-inner"
    />
  </WrapperQC>
</template>
